import { CanvasGifImagePicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasGifImagePicker } from "./gif-image-picker";

let loadGifImagePick = !1;

export function bindGifImageCanvasPickerContribution(container) {
    loadGifImagePick || (loadGifImagePick = !0, container.bind(CanvasGifImagePicker).toDynamicValue((() => new DefaultCanvasGifImagePicker)).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasGifImagePicker));
}
//# sourceMappingURL=gif-image-module.js.map
